import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TAPPageNotFoundComponent } from '@ibe.components/not-found/page-not-found/page-not-found.tap.component';
import { INDRASiteIsDownComponent } from '@ibe.components/is-down/site-is-down/site-is-down.indra.component';
import { INDRABookingGuardService } from '@ibe.services/booking-guard.indra.service';
// import { CorpRootService } from '@ibe.services/corp-root.service';
import { ExamplesComponent } from '@ibe.services/mocks.tap/examples/examples.component';

const appRoutes: Routes = [
	{
		path: 'notavailable',
		component: INDRASiteIsDownComponent,
		data: { title: 'Be right back' }
	},
	{
		path: 'booking',
		loadChildren: './components/booking/booking.module#BookingModule',
		data: { title: 'TAP Air Portugal' },
		canActivate: [INDRABookingGuardService /*, CorpRootService*/],
		canActivateChild: [INDRABookingGuardService]
	},
	{
		path: 'my-bookings',
		loadChildren: './components/myb/myb.module#MybModule',
		data: { title: 'My Bookings' },
		canActivate: [INDRABookingGuardService]
	},
	{
		path: 'check-in',
		loadChildren: './components/check-in/check-in.module#CheckInModule',
		data: { title: 'Check-in' },
		canActivate: [INDRABookingGuardService]
	},
	/*
	}
		path: 'refunds',
		loadChildren: './components/refunds/refunds.module#RefundsModule',
		data: { title: 'Refunds' }
	},
	*/
	/*
	{
		path: 'corporate',
		loadChildren: './components/corporate/corporate.module#CorporateModule',
		data: { title: 'Corporate' }
	},
	*/
	{
		path: 'styleguide',
		loadChildren: './components/styleguide/styleguide.module#StyleguideModule',
		data: { title: 'Styleguide' }
	},
	{
		path: 'trans',
		loadChildren: './components/translation-toggle/translation-toggle.module#TranslationToggleModule',
		data: { title: 'Translation toggle' }
	},
	{ path: 'examples', component: ExamplesComponent }, // only for testing use-case
	{ path: '', /*canActivate: [CorpRootService],*/ redirectTo: '/booking', pathMatch: 'full' }
	
	// { path: '', redirectTo: '/booking', pathMatch: 'full' },
	// { path: '**', component: TAPPageNotFoundComponent, loadChildren: './components/booking/booking.module#BookingModule', data: { title: 'Page not found' } }
	// {
	// 	path: 'not-found',
	// 	loadChildren: './components/not-found/not-found.module#TAPNotFoundModule'
	// },
	// {
	// 	path: '**',
	// 	redirectTo: 'not-found',
	// 	pathMatch: 'full'
	// }
];

@NgModule({
	imports: [
		RouterModule.forRoot(
			appRoutes,
			{
				enableTracing: false
			} // <-- debugging purposes only
		)
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
